module.exports = __webpack_public_path__ + "static/media/ar1.56a22be5.png";